export const imgUrl = `https://eces-glossary.com/public`;
